import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Login from "../pages/auth/login/Login";
import Landing from "../pages/landing/Landing";
import SpreadPrice from "../pages/market-watch/option/spread-price/SpreadPrice";
import Recommended from "../pages/recommended/Recommended";
import { authentication } from "../lib/dashboard/actions";
import ProtectedRoute from "../components/ProtectedRoute";
import ProfileProvider from "../context/profile/ProfileContext";
import Profile from "../pages/profile/Profile";
import DoemstMarketTopPriceChanges from "../pages/domestic-market/top-price-changes/DomesticMarketTopPriceChanges";
import Subscription from "../pages/subscription/Subscription";
import Orders from "../pages/subscription/orders/Orders";
import Transaction from "../pages/profile/transaction/Transaction";
import Error404 from "../components/404/Error404";
import Dashboard from "../pages/dashboard/Dashboard";

// context providers
import { SpreadPriceProvider, TicketProvider } from "../context/";
import ForgotPass from "../pages/auth/forgotPassword/ForgotPass";
import Signup from "../pages/auth/signup/Signup";
import RecommendedSetting from "../pages/recommended/recommended-setting/RecommendedSetting";
import { RecommendedProvider } from "../context";
import DashboardProvider from "../context/dashboard/DashboardContext";
import MarketWatchStockProvider from "../context/market-watch/MarketWatchStockContext";
import MarketWatchSingleStock from "../pages/market-watch/stock/MarketWatchSingleStock";
import MarketWatchStocks from "../pages/market-watch/stock/MarketWatchStocks";
import MarketWatchOptions from "../pages/market-watch/option/MarketWatchOptions";
import MarketWatchSingleOption from "../pages/market-watch/option/MarketWatchSingleOption";
import MarketWatchOptionProvider from "../context/market-watch/MarketWatchOptionContext";
import Ticket from "../pages/ticket/Ticket";
import SingleTicket from "../pages/ticket/SingleTicket";
import AddTicket from "../pages/ticket/AddTicket";
import DerivativesCommodityMarket from "../pages/derivatives/commodity-market/DerivativesCommodityMarket";
import DerivativesStockOption from "../pages/derivatives/stock-option/DerivativesStockOption";
import DerivativesStrategies from "../pages/derivatives/strategies/DerivativesStrategies";
import CommodityMarketProvider from "../context/derivatives/commodity-market/DerivativesCommodityMarketContext";
import StrategiesProvider from "../context/derivatives/strategies/DerivativesStrategiesContext";
import DoemstMarketTopPriceChangesProvider from "../context/domestic-market/DomesticMarketTopPriceChangesContext";
import GlobalMarketTopPriceChanges from "../pages/global-market/top-price-changes/GlobalMarketTopPriceChanges";
import GlobalMarketTopPriceChangesProvider from "../context/global-market/GlobalMarketTopPriceChangesContext";
import RoiStockProvider from "../context/roi/stock/RoiStockContext";
import RoiStock from "../pages/roi/stock/RoiStock";
import { RoiIndustries } from "../pages/roi/industry/RoiIndustries";
import RoiIndustryProvider from "../context/roi/industry/RoiIndustryContext";
import DerivativesCommodityMarketFutureContracts from "../pages/derivatives/commodity-market/future-contracts/DerivativesCommodityMarketFutureContracts";
import RoiPersonalWatch from "../pages/roi/personal-watch/RoiPersonalWatch";
import RoiPersonalWatchProvider from "../context/roi/personal-watch/RoiPersonalWatchContext";
import MonthlyStockSalesProvider from "../context/domestic-market/monthly-stock-sales/DomesticMarketMonthlyStockSalesContext";
import DomesticMarketMonthlyStockSales from "../pages/domestic-market/monthy-stock-sales/DomesticMarketMonthlyStockSales";
import History from "../pages/derivatives/history/History";
import HistoryProvider from "../context/derivatives/history/HistoryContext";
import GlobalMarketProductPriceChart from "../pages/global-market/product-price-chart/GlobalMarketProductPriceChart";
import GlobalMarketProductPriceChartProvider from "../context/global-market/GlobalMarketProductPriceChartContext";
import DomesticMarketProductPriceChart from "../pages/domestic-market/product-price-chart/DomesticMarketProductPriceChart";
import OptionCalculatorProvider from "../context/derivatives/calculator/OptionCalculatorContext";
import OptionCalculator from "../pages/derivatives/calculator/OptionCalculator";
import DomesticMarketProductPriceChartProducerProvider from "../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartProducerContext";
import DomesticMarketProductPriceChartCategoryProvider from "../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartCategoryContext";
import DomesticMarketProductPriceChartProvider from "../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartContext";
import GlobalMarketSpreadPriceProvider from "../context/global-market/GlobalMarketSpreadPriceContext";
import GlobalMarketSpreadPrice from "../pages/global-market/spread-price/GlobalMarketSpreadPrice";
import DomesticMarketSpreadPriceProvider from "../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceContext";
import DomesticMarketSpreadPrice from "../pages/domestic-market/spread-price/DomesticMarketSpreadPrice";
import DomesticMarketSpreadPriceCategoryProvider from "../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceCategoryContext";
import DomesticMarketSpreadPriceProducerProvider from "../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceProducerContext";
import SubscriptionProvider from "../context/subscription/SubscriptionContext";
import OrdersProvider from "../context/subscription/orders/OrdersContext";

export const router = createBrowserRouter([
  {
    path: "/",
    element:
      <DashboardProvider>
        <Landing />
      </DashboardProvider>,
    errorElement: <Error404 />,
  },
  {
    path: "/login",
    element: (
      <ProtectedRoute>
        <Login />
      </ProtectedRoute>
    ),
    errorElement: <Error404 />,
    action: authentication,
  },

  {
    path: "/signup",
    element: <Signup />,
    errorElement: <Error404 />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPass />,
    errorElement: <Error404 />,
  },
  {
    path: "/subscription",
    element: (
      <SubscriptionProvider>
        <Subscription />
      </SubscriptionProvider>
    ),
    errorElement: <Error404 />,
  },
  {
    path: "/subscription/orders",
    element: (
      <SubscriptionProvider>
        <OrdersProvider>
          <Orders />
        </OrdersProvider>
      </SubscriptionProvider>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardProvider>
          <App />
        </DashboardProvider>
      </ProtectedRoute>
    ),
    errorElement: <Error404 />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "profile",
        children: [
          {
            path: "",
            element: (
              <ProfileProvider>
                <Profile />
              </ProfileProvider>
            ),
          },
          {
            path: "transaction",
            element: <Transaction />,
          },
        ],
      },
      {
        path: "recommended",
        children: [
          {
            path: "",
            element: (
              <RecommendedProvider>
                <Recommended />
              </RecommendedProvider>
            ),
          },
          {
            path: "setting",
            element: (
              <RecommendedProvider>
                <RecommendedSetting />
              </RecommendedProvider>
            ),
          },
        ],
      },
      {
        path: "market-watch",
        children: [
          {
            path: "stocks",
            element: <MarketWatchStocks />,
          },

          //market watch stocks
          {
            path: "stocks/money_flow",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },
          {
            path: "stocks/buy_pressure",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },
          {
            path: "stocks/buy_value",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },
          {
            path: "stocks/buy_ratio",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },
          {
            path: "stocks/sell_ratio",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },
          {
            path: "stocks/value_change",
            element: (
              <MarketWatchStockProvider>
                <MarketWatchSingleStock />
              </MarketWatchStockProvider>
            ),
          },

          //market watch options
          {
            path: "options",
            element: <MarketWatchOptions />,
          },
          {
            path: "options/call_value_change",
            element: (
              <MarketWatchOptionProvider>
                <MarketWatchSingleOption />
              </MarketWatchOptionProvider>
            ),
          },
          {
            path: "options/put_value_change",
            element: (
              <MarketWatchOptionProvider>
                <MarketWatchSingleOption />
              </MarketWatchOptionProvider>
            ),
          },
          {
            path: "options/option_price_spread",
            element: (
              <SpreadPriceProvider>
                <SpreadPrice />
              </SpreadPriceProvider>
            ),
          },
        ],
      },
      {
        path: "derivatives",
        children: [
          {
            path: "calculator",
            element: (
              <OptionCalculatorProvider>
                <OptionCalculator />
              </OptionCalculatorProvider>
            ),
          },
          {
            path: "history",
            element: (
              <HistoryProvider>
                <History />
              </HistoryProvider>
            ),
          },
          {
            path: "commodity-market",
            element: (
              <StrategiesProvider>
                <CommodityMarketProvider>
                  <DerivativesCommodityMarket />
                </CommodityMarketProvider>
              </StrategiesProvider>
            ),
          },
          {
            path: "commodity-market/strategies",
            element: (
              <StrategiesProvider>
                <DerivativesStrategies />
              </StrategiesProvider>
            ),
          },
          {
            path: "commodity-market/future-contracts",
            element: (
              <CommodityMarketProvider>
                <DerivativesCommodityMarketFutureContracts />
              </CommodityMarketProvider>
            ),
          },
          {
            path: "stock-option",
            element: (
              <StrategiesProvider>
                <DerivativesStockOption />
              </StrategiesProvider>
            ),
          },
          {
            path: "stock-option/strategies",
            element: (
              <StrategiesProvider>
                <DerivativesStrategies />
              </StrategiesProvider>
            ),
          },
        ],
      },
      {
        path: "domestic-market",
        children: [
          {
            path: "top-price-changes",
            element: (
              <DoemstMarketTopPriceChangesProvider>
                <DoemstMarketTopPriceChanges />
              </DoemstMarketTopPriceChangesProvider>
            ),
          },
          {
            path: "monthly-stock-sales",
            element: (
              <MonthlyStockSalesProvider>
                <DomesticMarketMonthlyStockSales />
              </MonthlyStockSalesProvider>
            ),
          },
          {
            path: "product-price-chart",
            element: (
              <DomesticMarketProductPriceChartProvider>
                <DomesticMarketProductPriceChartProducerProvider>
                  <DomesticMarketProductPriceChartCategoryProvider>
                    <DomesticMarketProductPriceChart />
                  </DomesticMarketProductPriceChartCategoryProvider>
                </DomesticMarketProductPriceChartProducerProvider>
              </DomesticMarketProductPriceChartProvider>
            ),
          },
          {
            path: "spread-price",
            element: (
              <DomesticMarketSpreadPriceProvider>
                <DomesticMarketSpreadPriceCategoryProvider>
                  <DomesticMarketSpreadPriceProducerProvider>
                    <DomesticMarketSpreadPrice />
                  </DomesticMarketSpreadPriceProducerProvider>
                </DomesticMarketSpreadPriceCategoryProvider>
              </DomesticMarketSpreadPriceProvider>
            ),
          },
        ],
      },

      {
        path: "global-market",
        children: [
          {
            path: "top-price-changes",
            element: (
              <GlobalMarketTopPriceChangesProvider>
                <GlobalMarketTopPriceChanges />
              </GlobalMarketTopPriceChangesProvider>
            ),
          },
          {
            path: "product-price-chart",
            element: (
              <GlobalMarketProductPriceChartProvider>
                <GlobalMarketProductPriceChart />
              </GlobalMarketProductPriceChartProvider>
            ),
          },
          {
            path: "spread-price",
            element: (
              <GlobalMarketSpreadPriceProvider>
                <GlobalMarketSpreadPrice />
              </GlobalMarketSpreadPriceProvider>
            ),
          },
        ],
      },

      {
        path: "roi",
        children: [
          {
            path: "roi-stock",
            element: (
              <RoiStockProvider>
                <RoiStock />
              </RoiStockProvider>
            ),
          },
          {
            path: "roi-industry",
            element: (
              <RoiIndustryProvider>
                <RoiIndustries />
              </RoiIndustryProvider>
            ),
          },
          {
            path: "roi-personal-watch",
            element: (
              <RoiPersonalWatchProvider>
                <RoiPersonalWatch />
              </RoiPersonalWatchProvider>
            ),
          },
        ],
      },
      {
        path: "ticket",
        element: (
          <TicketProvider>
            <Ticket />
          </TicketProvider>
        ),
        children: [
          { path: ":ticketId", element: <SingleTicket /> },
          { path: "add", element: <AddTicket /> },
        ],
      },
    ],
  },
]);
